"use strict";import{html as t}from"@cisco-u/base";export function youtubeIcon({height:l=16,width:r=16,hidden:e=!1,title:o="Youtube",type:a="",hover:i=!1}={}){return a==="dark"?t`<svg
      width=${r}
      height=${l}
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="${e?"true":"false"}"
      aria-label="${o}"
      role="img"
      style=${i?"color: var(--color-blue-primary);":"color: var(--color-white);"}
    >
      <circle cx="16" cy="16" r="16" fill="currentColor" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7363 21.7981C13.224 21.9687 18.773 21.9687 21.2643 21.7981C23.9594 21.6132 24.2759 20.3012 24.2972 16.0001C24.2759 11.7074 23.963 10.3871 21.2643 10.2022C18.7742 10.0316 13.224 10.0316 10.7363 10.2022C8.04237 10.3871 7.72474 11.6991 7.70459 16.0001C7.72474 20.2929 8.03881 21.6132 10.7363 21.7981ZM13.6283 13.2246L19.4559 15.9955L13.6283 18.776V13.2246Z"
        fill="#1B1C1D"
      />
    </svg> `:t`<svg
    width=${r}
    height=${l}
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${e?"true":"false"}"
    aria-label="${o}"
    role="img"
    style=${i?"color: var(--color-blue-primary);":"color: var(--color-gray-100);"}
  >
    <circle cx="16" cy="16" r="16" fill="currentColor" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7363 21.7981C13.224 21.9687 18.773 21.9687 21.2643 21.7981C23.9594 21.6132 24.2759 20.3012 24.2972 16.0001C24.2759 11.7074 23.963 10.3871 21.2643 10.2022C18.7742 10.0316 13.224 10.0316 10.7363 10.2022C8.04237 10.3871 7.72474 11.6991 7.70459 16.0001C7.72474 20.2929 8.03881 21.6132 10.7363 21.7981ZM13.6283 13.2246L19.4559 15.9955L13.6283 18.776V13.2246Z"
      fill="#F7F5F4"
    />
  </svg>`}
//# sourceMappingURL=youtube.js.map
